/**
 * O endereco que veio de fora so vale se for um endereco de navegador.
 *
 * Duas coisas que a casa mostra como link nao sao escritas por ninguem daqui:
 * o `connectUrl` que o servico de IPTV manda no pareamento, e o `listenUrl`
 * que estava gravado no documento da musica. As duas chegam como texto solto,
 * e as duas viram `href` no site e `Linking.openURL` no celular sem passar por
 * lugar nenhum no meio.
 *
 * No navegador, `href="javascript:..."` roda na nossa propria pagina. No
 * celular e pior de outro jeito: o `Linking.openURL` entrega o endereco ao
 * sistema, e o sistema abre qualquer aplicativo que diga ser dono daquele
 * comeco. Nos dois casos quem escolhe o que acontece e quem escreveu o texto.
 *
 * Entao a conta se faz uma vez so, e se faz na entrada: o valor e limpo e
 * conferido no ponto em que vira nosso, e nao nos onze lugares que o usam
 * depois. Guardar o cru e conferir na hora de abrir seria a mesma regra
 * espalhada, que e como o furo do `quadro.ts` nasceu — repetida, ela envelhece
 * so num dos lados.
 *
 * O Flutter tambem grava o `listenUrl` cru; a diferenca daqui esta anotada no
 * `estadoDeMapa`.
 *
 * Quem cobra e o `test/endereco.mjs`.
 */

/**
 * O endereco do jeito que o navegador o le: sem branco nas pontas e sem
 * tabulacao nem quebra de linha em lugar nenhum.
 *
 * Nao e isto que barra o `javascript:` — quem barra e a lista fechada de
 * esquemas logo abaixo, e ela barra tanto o disfarcado quanto o limpo. A
 * limpeza esta aqui por fidelidade: o navegador apaga esses tres caracteres
 * antes de ler o endereco, entao e este o endereco que existe de verdade, e e
 * ele que a gente guarda. Endereco bom com um espaco sobrando na ponta
 * continua bom.
 *
 * Ela vira defesa no dia em que alguem trocar a lista fechada por uma lista de
 * proibidos: ai `java` + tabulacao + `script:` passa por qualquer comparacao
 * feita no texto cru. O `test/endereco.mjs` cobra as duas coisas de uma vez, e
 * so cobra essa troca porque a limpeza continua aqui.
 *
 * Sao esses tres e mais nenhum: espaco no meio o navegador escreve como `%20`,
 * nao apaga, e apaga-lo aqui mudaria endereco que estava certo.
 */
function limpar(bruto: string): string {
  return bruto.trim().replace(/[\t\n\r]/g, '');
}

/**
 * E um endereco que o navegador abre como pagina?
 *
 * So `http` e `https`, e so com casa depois das duas barras. `https:` sozinho
 * nao basta: `https:coisa` e caminho relativo, nao endereco de lugar nenhum.
 */
export function enderecoDeNavegador(bruto: string): boolean {
  return /^https?:\/\/[^/?#]/i.test(limpar(bruto));
}

/**
 * O endereco de fora, quando ele serve; a reserva, quando nao.
 *
 * A reserva nao e enfeite de erro: no pareamento ela e `''`, e a tela entao
 * nao mostra botao nenhum; na musica ela e a busca que todos os outros
 * caminhos do modulo ja montam, entao o link continua levando a mesma musica.
 *
 * Devolve o endereco limpo, e nao o cru: se o cru voltasse, o navegador ainda
 * leria o `javascript:` que a limpeza acabou de descobrir.
 */
export function enderecoDeFora(bruto: string, reserva: string): string {
  const limpo = limpar(bruto);
  return enderecoDeNavegador(limpo) ? limpo : reserva;
}
